<template>
  <div
    class="chat"
    :class="{'chat--small': isMobile}"
  >
    <div
      class="chat__backdrop"
      :class="{'chat__backdrop--small': isMobile}"
    />
    <chat-list
      class="chat__messages"
      :class="{'chat__messages--open': innerIsOpen}"
      v-bind="{...$attrs, isMobile}"
    />
    <template v-if="innerIsOpen">
      <chat-box
        :small="isMobile"
        :inverse="isMobile"
        :emojis="!isMobile"
        v-on="$listeners"
      />
    </template>
  </div>
</template>

<script>
import ChatList from './ChatList';
import ChatBox from './ChatBox';

export default {
  name: 'Chat',
  components: {
    ChatBox,
    ChatList,
  },
  inheritAttrs: false,
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerIsOpen() {
      // Desktop will be always open
      if (!this.isMobile) {
        return true;
      }

      return this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.chat{
  display: block;
  height: 48px;
  overflow: visible;
  position: relative;
  &__backdrop {
    position: absolute;
    left: 0;
    bottom: calc(100% + 17px);
    width: 1024px;
    height: 600px;
    background-image: linear-gradient(30deg, rgba(black, 0.5) 0%, rgba(black, 0) 50%);
    mix-blend-mode: multiply;
    &--small{
      pointer-events: none;
      bottom: -60px;
      left: -1rem;
      background-image: linear-gradient(to top, rgba(black, 0.5) 0%, rgba(black, 0) 50%);
    }
  }
  &__messages{
    position: absolute;
    left: 0;
    bottom: 0;
    &--open {
      bottom: calc(100% + 30px);
    }
  }
}
</style>
